// startup
// Load entry module and return exports
// This entry module can't be inlined because the eval-source-map devtool is used.
var __webpack_exports__ = {};
__webpack_modules__["./js/main.js"]();
